<template>
  <div class="container category" :class="{ containerPadding: $route.query.type !== 'inside' }">
    <follow @follow="followFn"></follow>
    <div class="Header" :style="follow ? { top: '0.5rem' } : { top: '0' }">
      <ul>
        <li
          :class="{ navColor: topNavIndex == index }"
          v-for="(item, index) of navList"
          @click="headerClick(index)"
        >
          {{ item }}
        </li>
      </ul>
      <div class="feature flex-ac">
        <div class="search flex-1 flex-js-ac" @click="searchClick">
          <div class="inp over-ell-1">{{ defaultSearch ? '搜索“' + defaultSearch + '”' : '' }}</div>
          <div class="searchBtn f14 ws-n">
            <van-icon name="search" color="#ffffff" size="0.2rem" />
            搜索
          </div>
        </div>
        <div class="kefu" @click="keFu">
          <img src="../../assets/images/service.png" />
        </div>
      </div>
    </div>
    <div
      v-if="headerIndex == 0"
      id="cup"
      :style="follow ? { 'margin-top': '1.38rem' } : { 'margin-top': '0.88rem' }"
    >
      <van-tabs
        @click="channelSeriesTabHandle"
        class="channel_series_van_tabs pro_cate_list"
        :class="{ 'channel_series_van_tabs_empty': !channelSeriesTabs.length || !isChannelMode }"
        v-model="activeSeriesId"
        :sticky="allGoodsList.length > 0"
        :offset-top="channelSeriesStickyOffset"
        :z-index="9"
        line-width="0.24rem"
        :ellipsis="false"
        line-height="0.02rem"
      >
        <van-tab
          v-for="tab in (channelSeriesTabs.length ? channelSeriesTabs : [{seriesId: '', seriesName: ''}])"
          :key="tab.seriesId"
          :name="String(tab.seriesId)"
          :title="tab.seriesName"
        >
          <div class="cup_scroller_wrap">
            <Scroller
              :immediateCheck="false"
              :is-finished-data.sync="finished"
              :is-loading-data.sync="loading"
              :is-refresh-data.sync="refresh"
              :no-data-text-data.sync="noDataText"
              @on-infinite="onInfinite"
              @on-refresh="onRefresh"
              ref="my_scroller"
            >
              <div class="pro_list w-100 flex fw-w over-h bg-F5 pt10 pl12 pr12">
              <div :key="index" class="prolist_item w-50 mb10" v-for="(item, index) of allGoodsList">
                <product-item
                  :markPointData="{
                    scenepoint: 'ALLGOODS',
                    scenedesc: allGoodsList[index].name
                  }"
                  :prolistIndex="index"
                  :prolistItem="item"
                  :skuSwitch="'1'"
                  :className="'width100'"
                  class="bg-F h-100"
                ></product-item>
              </div>
            </div>
            </Scroller>
          </div>
        </van-tab>
      </van-tabs>
    </div>
    <div
      id="cup"
      v-else-if="headerIndex == 1"
      class="flex"
      :style="follow ? { 'margin-top': '1.38rem' } : { 'margin-top': '0.9rem' }"
    >
      <van-sidebar class="flex-s scrollbar-none" v-model="activeKey">
        <div style="background: #ffffff">
          <van-sidebar-item
            :index="index"
            :activeKey="activeKey"
            :class="{ radius_t: index == activeKey - 1, radius_b: index == activeKey + 1 }"
            v-for="(item, index) of categoryList"
            :key="index"
            :title="item.sortName"
          />
        </div>
      </van-sidebar>
      <div class="actregion" style="background: #ffffff">
        <category_act-item
          v-if="itemlist && itemlist.sortName"
          :cateItem="itemlist"
          :markButtonCodeData="{
            buttontext: itemlist.sortName ? itemlist.sortName : '',
            buttonCode: headerIndex == 0 ? 'allgoods' : headerIndex == 1 ? 'classify' : 'category'
          }"
        ></category_act-item>
        <div
          class="categoryList"
          v-if="itemlist && itemlist.subSortList && itemlist.subSortList.length"
        >
          <categoryItem
            v-for="(item, index) in itemlist.subSortList"
            :key="index"
            :markButtonCodeData="{
              buttontext: itemlist.sortName ? itemlist.sortName : '',
              buttonCode: headerIndex == 0 ? 'allgoods' : headerIndex == 1 ? 'classify' : 'category'
            }"
            :cateItem="item"
            :type="0"
            :widthspan="8"
          ></categoryItem>
        </div>
      </div>
    </div>
    <div
      v-else
      id="cup"
      :style="follow ? { 'margin-top': '1.38rem' } : { 'margin-top': '0.88rem' }"
    >
      <div class="categoryContent">
        <div
          class="skinTest"
          v-if="itemlist && itemlist.length > 0 && $store.state.skinTextCategoryShow == 1"
        >
          <skinTest :page="'category'"></skinTest>
        </div>
        <div class="categoryList" v-if="itemlist && itemlist.length">
          <categoryItem
            :cateItem="itemlist"
            :key="index"
            :markButtonCodeData="{
              buttonCode: headerIndex == 0 ? 'allgoods' : headerIndex == 1 ? 'classify' : 'category'
            }"
            :type="1"
            :widthspan="6"
          ></categoryItem>
        </div>
      </div>
    </div>
    <div class="floatBtn_new">
      <img
        v-if="isnewpersontask"
        @click="newpersontask"
        src="/static/images/new-person/newpersontask@2x.png"
      />
    </div>
    <div v-if="$route.query.type !== 'inside'">
      <footer-comp v-if="$route.query.channelid" :footer-index="index" :tabbar-text1="tabbarText1" :show-only-the-entrance="[tabbarText1 ? tabbarText1 : '首页', '分类']"></footer-comp>
      <footer-comp v-else :isNewPage="isNewPage" :footer-index="index" :cartnum="cartnum"></footer-comp>
    </div>
  </div>
</template>

<script>
import productItem from '../common/productItem'
import Scroller from '../common/Scroller'
import skinTest from '../common/skinTest'
import advertisingSpace from '../common/advertisingSpace'
import categoryItem from './categoryItem'
import footerComp from '../common/footerComp'
import follow from '../common/follow'
import {
  isWeixin,
  fenxiang,
  kefu,
  Base64,
  cartNum,
  goXcxCreateBtnFn,
  clickburiedPoint
} from '../../assets/common/js/config'
import category_actItem from './category_actItem'
import Vue from 'vue'
import { Tab, Tabs } from 'vant'

Vue.use(Tab).use(Tabs)
Vue.config.ignoredElements = ['wx-open-launch-weapp']

export default {
  name: 'category',
  data() {
    return {
      index: 1,
      defaultSearch: '',
      categoryList: [],
      itemlist: null,
      follow: null,
      cartnum: 0,
      isNewPage: 0,
      /** 与 navList 下标对应：顶栏「全部 / 分类 / 系列」当前选中项 */
      topNavIndex: 1,
      headerIndex: 1,
      activeKey: 0,
      isnewpersontask: 0,
      newpersonjump: '',
      allGoodsList: [],
      refresh: false,
      loading: false,
      finished: false,
      nowPage: 0,
      noDataText: '',
      /** 频道「全部」下系列 tab，接口返回 list[{ seriesId, seriesName }] */
      channelSeriesTabs: [],
      activeSeriesId: '',
      channelSeriesTabsLoaded: false,
      channelSeriesTabChannelKey: '',
      tabbarText1: '',
      channelSeriesShow: false
    }
  },
  components: {
    skinTest,
    categoryItem,
    footerComp,
    follow,
    advertisingSpace,
    category_actItem,
    productItem,
    Scroller
  },
  computed: {
    channelIdVal() {
      var v = this.$route.query.channelid
      if (v === undefined || v === null || v === '') return ''
      return Array.isArray(v) ? String(v[0]) : String(v)
    },
    isChannelMode() {
      return this.channelIdVal !== ''
    },
    /** 链接上是否带有 navid（含 navid=0） */
    hasNavIdInRoute() {
      var v = this.$route.query.navid
      return !(v === undefined || v === null || v === '')
    },
    /** 解析后的 navid，无效则为 null */
    navIdVal() {
      if (!this.hasNavIdInRoute) return null
      var v = this.$route.query.navid
      var raw = Array.isArray(v) ? v[0] : v
      var num = parseInt(raw, 10)
      return isNaN(num) ? null : num
    },
    /** 链接 sortid（频道分类左侧与 sortList 项 id 类字段对齐） */
    sortIdInRoute() {
      var v = this.$route.query.sortid
      if (v === undefined || v === null || v === '') return ''
      return String(Array.isArray(v) ? v[0] : v)
    },
    /**
     * 有 channelid：['全部','分类']；仅有 navid 且无 channelid：['全部','系列']；否则三 Tab
     */
    navList() {
      if (this.channelIdVal !== '') {
        return ['全部', '分类']
      }
      if (this.hasNavIdInRoute) {
        return ['全部', '系列']
      }
      return ['全部', '分类', '系列']
    },
    /** 与固定 Header 对齐：导航0.44rem + 搜索行0.44rem；有 follow 时再加 0.5rem（与 indexChannel 一致用 rem） */
    channelSeriesStickyOffset() {
      return this.follow ? '1.38rem' : '0.88rem'
    }
  },
  watch: {
    activeKey() {
      this.itemlist = null
      setTimeout(() => {
        this.itemlist = this.categoryList[this.activeKey]
        this.$nextTick(() => {
          setTimeout(() => {
            goXcxCreateBtnFn(this)
          }, 500)
        })
      })
    },
    isChannelMode(val) {
      if (val && this.headerIndex === 2) {
        this.applyDefaultTopNavFromRoute()
        this.categoryList = []
        this.itemlist = null
        this.getData()
      }
    },
    '$route.query': {
      handler() {
        this.applyDefaultTopNavFromRoute()
        this.channelSeriesTabsLoaded = false
        this.channelSeriesTabChannelKey = ''
        this.channelSeriesTabs = []
        this.activeSeriesId = ''
        this.nowPage = 1
        this.allGoodsList = []
        this.getData()
      },
      deep: true
    }
  },
  activated() {
    if (this.isChannelMode && this.headerIndex === 2) {
      this.applyDefaultTopNavFromRoute()
      this.categoryList = []
      this.itemlist = null
      this.getData()
    }
  },
  created() {
    this.applyDefaultTopNavFromRoute()
  },
  mounted: function () {
    if (!isWeixin()) {
      if (this.waptoken.waptoken && this.waptoken.waptoken == this.waptoken.tourists) {
        this.$store.commit('SKIN_PATH', 'classification')
        if (this.$route.query.type !== 'inside') {
          this.$store.commit('PATH_VALUE', '')
        }
      }
    } else {
      var base = new Base64()
      fenxiang({
        type: 'list',
        dataStr: 'type=list&params=' + base.encode(JSON.stringify({ type: 'inside' })),
        path: 'category'
      })
    }
  },
  beforeRouteEnter(to, from, next) {
    if (from.path == '/' && from.name != 'homePage') {
      // 当前页面刷新不需要切换位置
      next((vm) => {
        vm.getData()
      })
    } else {
      next((vm) => {
        cartNum((num) => (vm.cartnum = num))
        vm.getData()
        // setTimeout(function () {
        //   window.scrollTo(0, sessionStorage.askPositon, false)
        // }, 0) // 同步转异步操作
      })
    }
  },
  beforeRouteLeave(to, from, next) {
    //记录离开时的位置
    // sessionStorage.askPositon = parseInt(document.body.scrollTop) || parseInt(document.documentElement.scrollTop) || parseInt(window.pageYOffset)
    next()
  },
  methods: {
    /** 按链接规则默认顶栏：有 channelid→分类；仅有 navid→全部；无参→分类 */
    applyDefaultTopNavFromRoute() {
      if (this.channelIdVal !== '') {
        this.topNavIndex = 1
      } else if (this.hasNavIdInRoute) {
        this.topNavIndex = 0
      } else {
        this.topNavIndex = 1
      }
      if (this.topNavIndex >= this.navList.length) {
        this.topNavIndex = Math.max(0, this.navList.length - 1)
      }
      this.syncHeaderIndexFromTopNav()
    },
    /** topNavIndex + navList → 原 headerIndex（0 全部 / 1 分类 / 2 系列） */
    syncHeaderIndexFromTopNav() {
      var list = this.navList
      var i = this.topNavIndex
      if (i < 0 || i >= list.length) {
        this.topNavIndex = 0
        i = 0
      }
      var label = list[i]
      if (label === '全部') {
        this.headerIndex = 0
      } else if (label === '分类') {
        this.headerIndex = 1
      } else if (label === '系列') {
        this.headerIndex = 2
      } else {
        this.headerIndex = 1
      }
    },
    /** 按 sortid 匹配 sortList 项，返回左侧菜单下标，未匹配返回 -1 */
    findSidebarIndexBySortId: function (sortList, sortIdStr) {
      if (!sortList || !sortList.length || !sortIdStr) return -1
      var target = String(sortIdStr)
      for (var i = 0; i < sortList.length; i++) {
        var it = sortList[i]
        if (!it) continue
        var candidates = [
          it.sortId,
          it.goodsSortId,
          it.id,
          it.sort_id,
          it.goods_sort_id
        ]
        for (var j = 0; j < candidates.length; j++) {
          if (candidates[j] !== undefined && candidates[j] !== null && String(candidates[j]) === target) {
            return i
          }
        }
      }
      return -1
    },
    getData: function () {
      if (this.isChannelMode && this.headerIndex === 2) {
        this.topNavIndex = 1
        this.headerIndex = 1
      }
      clickburiedPoint({
        data: {
          buttonCode:
            this.headerIndex == 0 ? 'allgoods' : this.headerIndex == 1 ? 'classify' : 'category',
          buttontext: this.navList[this.topNavIndex] || ''
        }
      })
      if (this.headerIndex == 0) {
        this.nowPage = 1
        if (this.isChannelMode) {
          this.ensureChannelSeriesTabsThen(() => {
            this.getData0()
          })
        } else {
          this.getData0()
        }
      } else if (this.headerIndex == 1) {
        this.getData1()
      } else {
        this.getData2()
      }
      if (!this.isChannelMode) {
        this.$newuserFn((data) => {
          if (data.code == 200) {
            this.isnewpersontask = data.isnewpersontask
            this.newpersonjump = data.newpersonjump ? data.newpersonjump : ''
          }
        })
      }
    },
    ensureChannelSeriesTabsThen: function (cb) {
      var that = this
      if (!this.isChannelMode) {
        if (typeof cb === 'function') cb()
        return
      }
      if (
        this.channelSeriesTabsLoaded &&
        this.channelSeriesTabChannelKey === this.channelIdVal
      ) {
        if (typeof cb === 'function') cb()
        return
      }
      var url =
        this.$ajax.getMarketTypeList_URL +
        '?channelid=' +
        encodeURIComponent(this.channelIdVal)
      this.$customRequestAjax(url)
        .then(function (res) {
          that.channelSeriesTabsLoaded = true
          that.channelSeriesTabChannelKey = that.channelIdVal
          if (res.data && res.data.code === 200 && Array.isArray(res.data.list)) {
            that.channelSeriesTabs = res.data.list.filter(function (x) {
              return x && x.seriesId != null && String(x.seriesId) !== ''
            })
            if (that.channelSeriesTabs.length) {
              var sid0 = String(that.channelSeriesTabs[0].seriesId)
              var keep = that.channelSeriesTabs.some(function (x) {
                return String(x.seriesId) === String(that.activeSeriesId)
              })
              if (!that.activeSeriesId || !keep) {
                that.activeSeriesId = sid0
              }
            } else {
              that.activeSeriesId = ''
            }
          } else {
            that.channelSeriesTabs = []
            that.activeSeriesId = ''
          }
          if (typeof cb === 'function') cb()
        })
        .catch(function () {
          that.channelSeriesTabsLoaded = true
          that.channelSeriesTabChannelKey = that.channelIdVal
          that.channelSeriesTabs = []
          that.activeSeriesId = ''
          if (typeof cb === 'function') cb()
        }).finally(() => {
          that.channelSeriesShow = true
        })
    },
    /** vant Tabs 点击，参数为 van-tab 的 name（与 seriesId 一致）；勿与 v-model 同步顺序比较，避免漏请求 */
    channelSeriesTabHandle: function (name) {
      var sid = name != null ? String(name) : ''
      if (!sid) return
      this.activeSeriesId = sid
      this.nowPage = 1
      this.allGoodsList = []
      this.finished = false
      this.loading = true
      this.getData0()
    },
    getData0: function () {
      var use_series_tabs =
        this.isChannelMode &&
        this.channelSeriesTabs.length > 0 &&
        this.activeSeriesId !== ''
      var item_path = this.$ajax.getItemList_URL
      var urlProduct =
        item_path +
        '?cat_id=&pageno=' +
        this.nowPage +
        '&pagesize=' +
        this.pagesize
      if (use_series_tabs) {
        urlProduct += '&seriesId=' + encodeURIComponent(this.activeSeriesId)
      }
      var that = this
      that.$customRequestAjax(urlProduct).then((res) => {
        if (res.data.code === 200) {
          if (that.nowPage === 1) {
            that.allGoodsList = res.data.itemlist
            that.refresh = false
          } else {
            that.allGoodsList = that.allGoodsList.concat(res.data.itemlist)
          }
          that.loading = false
          if (res.data.itemlist.length < that.pagesize) {
            that.finished = true
          } else {
            that.finished = false
          }
        }
      })
    },
    getData1: function () {
      // sessionStorage.removeItem('isLocationMaiList') // 记录刷新一次
      var url = this.isChannelMode
        ? this.$ajax.getMarketNaviList_URL +
          '?channelid=' +
          encodeURIComponent(this.channelIdVal)
        : this.$ajax.getMarketNaviList_URL
      var that = this
      that
        .$customRequestAjax(url)
        .then((res) => {
          if (res.data.code == 200) {
            that.tabbarText1 = res.data.tabbarText1 || ''
            that.categoryList = res.data.sortList
            setTimeout(() => {
              var key = that.activeKey
              if (
                that.isChannelMode &&
                that.sortIdInRoute &&
                that.categoryList &&
                that.categoryList.length
              ) {
                var si = that.findSidebarIndexBySortId(that.categoryList, that.sortIdInRoute)
                if (si >= 0) {
                  key = si
                  that.activeKey = key
                }
              } else if (
                that.navIdVal != null &&
                that.categoryList &&
                that.categoryList.length > that.navIdVal &&
                that.navIdVal >= 0
              ) {
                key = that.navIdVal
                that.activeKey = key
              }
              that.itemlist = that.categoryList[key]
              that.$nextTick(() => {
                setTimeout(() => {
                  goXcxCreateBtnFn(that)
                }, 500)
              })
            })
            if (res.data.default_search) {
              that.defaultSearch = res.data.default_search
            } else {
              that.defaultSearch = that.$store.state.defaultSearch
                ? that.$store.state.defaultSearch
                : ''
            }
          }
        })
        .catch((err) => {})
    },
    getData2: function () {
      if (this.isChannelMode) {
        return
      }
      // sessionStorage.removeItem('isLocationMaiList') // 记录刷新一次
      var url = this.$ajax.getSeriesNaviList_URL

      var that = this
      that
        .$customRequestAjax(url)
        .then((res) => {
          if (res.data.code == 200) {
            that.categoryList = res.data.list
            that.itemlist = null
            setTimeout(() => {
              that.itemlist = that.categoryList
              that.$nextTick(() => {
                setTimeout(() => {
                  goXcxCreateBtnFn(that)
                }, 500)
              })
            })
            if (res.data.default_search) {
              that.defaultSearch = res.data.default_search
            } else {
              that.defaultSearch = that.$store.state.defaultSearch
                ? that.$store.state.defaultSearch
                : ''
            }
          }
        })
        .catch((err) => {})
    },
    headerClick: function (idx) {
      window.scrollTo(0, 0)
      if (this.topNavIndex === idx) return
      this.topNavIndex = idx
      this.syncHeaderIndexFromTopNav()
      this.categoryList = []
      this.getData()
    },
    onRefresh() {
      this.refresh = true
      this.nowPage = 1
      this.allGoodsList = []
      this.getData0()
    },
    onInfinite() {
      this.loading = true
      this.finished = false
      var that = this
      // setTimeout(function () {
      that.nowPage++
      that.getData0()
      // }, 400)
    },
    newpersontask() {
      window.location = this.newpersonjump
    },
    followFn: function (data) {
      this.follow = data
    },
    searchClick: function () {
      this.$router.push('/search')
    },
    // 客服
    keFu: function () {
      // 登录校验
      if (!isWeixin()) {
        if (this.waptoken.waptoken && this.waptoken.waptoken == this.waptoken.tourists) {
          this.$router.push({
            path: '/login',
            query: {
              routeval: ''
            }
          })
        } else {
          kefu()
        }
      } else {
        kefu()
      }
    }
  }
}
</script>

<style scoped lang="scss">
.container {
  display: flex;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  flex-direction: column;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  -moz-flex-direction: column;
  -o-flex-direction: column;
  /*overflow: hidden;*/
  height: 100%;
  flex: 0;
  -webkit-flex: 0;
  -moz-flex: 0;
  -ms-flex: 0;
  -o-flex: 0;
  .Header {
    background: #fff;
    padding: 0 0.11rem;
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    z-index: 10;
    ul {
      height: 0.44rem;
      font-size: 0;
      flex: 1;
      text-align: center;
      li {
        display: inline-block;
        font-size: 0.17rem;
        color: #222222;
        margin-right: 0.67rem;
        transition: all 0.2s;
        margin-top: 0.1rem;
        &:first-of-type {
          margin-left: -0.2rem;
        }
        &:last-of-type {
          margin-right: -0.2rem;
        }
        &.navColor0 {
          color: #ffffff;
        }
        &.navColor {
          color: #fe0f41;
          font-weight: 600;
          position: relative;
          &:after {
            content: '';
            position: absolute;
            left: 0;
            right: 0;
            margin: 0 auto;
            display: block;
            width: 0.26rem;
            height: 0.03rem;
            background: linear-gradient(90deg, #fc0324 0%, #fc0324 100%);
          }
        }
      }
    }
    .feature {
      height: 0.44rem;
      .search {
        /*width: 3.23rem;*/
        margin-right: 0.1rem;
        height: 0.3rem;
        line-height: 0.3rem;
        font-size: 0.13rem;
        background: #ffffff;
        border-radius: 0.15rem;
        border: 0.01rem solid #fc0324;
        color: #999999;
        position: relative;
        .searchicon {
          font-size: 0;
          position: absolute;
          width: 0.2rem;
          height: 0.2rem;
          left: 0.1rem;
          top: 50%;
          transform: translateY(-50%);
          -webkit-transform: translateY(-50%);
          -moz-transform: translateY(-50%);
          -o-transform: translateY(-50%);
          -ms-transform: translateY(-50%);
          /*overflow: hidden;*/
          .van-icon-search {
            color: transparent;
            font-weight: 600;
            font-size: 0.2rem;
            height: 100%;
            background: url('../../assets/images/search3.png') no-repeat center;
            background-size: 100%;
          }
        }
        .inp {
          border: 0.01rem solid transparent;
          background: transparent;
          border-radius: 0.15rem;
          height: 0.3rem;
          line-height: 0.3rem;
          padding-left: 0.1rem;
          font-size: 0.13rem;
          color: #999999;
          -webkit-transition: all 0.35s;
          transition: all 0.35s;
          margin-right: 0.1rem;
        }
        .searchBtn {
          color: #ffffff;
          background: linear-gradient(92deg, #fc0324 0%, #f63a66 100%);
          border-radius: 0.15rem;
          flex-wrap: nowrap;
          padding: 0 0.12rem;
          height: 0.29rem;
          line-height: 0.3rem;
          .van-icon-search {
            position: initial;
            background: none;
            transform: translateY(0);
            vertical-align: middle;
            margin-right: 0.02rem;
          }
        }
      }
      .kefu {
        float: right;
        img {
          margin-top: 0.03rem;
          width: 0.2rem;
          height: 0.2rem;
        }
      }
    }
  }
  #cup {
    flex: 1;
    -webkit-flex: 1;
    -moz-flex: 1;
    -ms-flex: 1;
    -o-flex: 1;
    height: calc(100% - 0.88rem - 0.56rem);
    overflow: visible;
  }
  /** 频道「全部」系列 Tab：van-tabs sticky 吸顶在固定 Header 下方 */
  .channel_series_van_tabs {
    background: #ffffff;
    /deep/ .van-sticky--fixed {
      background: #ffffff;
    }
    /deep/ .van-tabs__wrap {
      position: relative;
      z-index: 2;
    }
    &.channel_series_van_tabs_empty {
      /deep/ .van-tabs__wrap {
        height: 0;
      }
    }
    // /deep/ .van-tabs__nav {
    //   background: transparent;
    //   padding: 0 0.12rem;
    // }
    // /deep/ .van-tabs__nav--line {
    //   padding-bottom: 0;
    // }
    // /deep/ .van-tabs__line {
    //   display: none;
    // }
    /deep/ .van-tabs__content {
      position: relative;
      z-index: 1;
    }
    // /deep/ .van-tab {
    //   flex: 0 0 auto !important;
    //   padding: 0 0.04rem;
    //   margin-right: 0.08rem;
    //   font-size: 0.12rem;
    //   color: #333333;
    //   line-height: 1.3;
    // }
    // /deep/ .van-tab:last-child {
    //   margin-right: 0;
    // }
    // /deep/ .van-tab__text {
    //   display: block;
    //   border: 0.01rem solid transparent;
    //   border-radius: 0.16rem;
    //   padding: 0.06rem 0.14rem;
    //   background: #f5f5f5;
    // }
    // /deep/ .van-tab--active .van-tab__text {
    //   color: #fc0324;
    //   background: #fee9ec;
    //   border-color: #fc0324;
    //   font-weight: 500;
    // }
  }
  .cup_scroller_wrap {
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
  }
  .pro_list {
    padding-bottom: calc(0.5rem + env(safe-area-inset-bottom));
    .prolist_item:nth-child(2n) {
      padding-left: 0.035rem;
    }
    .prolist_item:nth-child(2n-1) {
      padding-right: 0.035rem;
    }
    .pro_item {
      border-radius: 0.12rem;
      overflow: hidden;
    }
  }
  .van-sidebar {
    height: 100%;
    width: 28.6%;
    background: #f5f5f5;
    .van-sidebar-item--select::before {
      background: #ffffff;
    }
    .van-sidebar-item {
      text-align: center;
      font-size: 0.14rem;
      padding: 0.16rem 0;
      background: #f5f5f5;
    }
    .van-sidebar-item--select {
      color: #fc0324;
      font-size: 0.17rem;
      font-weight: normal;
      background: #ffffff;
    }
    .radius_t {
      border-radius: 0 0 0.12rem 0;
    }
    .radius_b {
      border-radius: 0 0.12rem 0 0;
    }
  }
  .actregion {
    width: 71.4%;
    height: 100%;
    overflow-y: auto;
    .categoryList {
      padding: 0;
    }
  }
  .skinTest {
    margin-top: 0.1rem;
  }
  .categoryList {
    background: #ffffff;
    margin: 0.1rem 0;
    padding: 0.17rem 0 0;
    border-radius: 0.08rem;
  }
  .categoryContent {
    height: calc(100%);
    overflow-y: auto;
    .categoryList {
      min-height: calc(100% - 0.22rem);
    }
    /*padding-top: 0.44rem;*/
  }
}
</style>



// WEBPACK FOOTER //
// src/components/category/category.vue